import { makeStyles } from 'tss-react/mui';
import { link } from '../../styles/jss/utils';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params) => ({
    pccStepContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: spacing.medium,
        cursor: 'pointer',
    },
    label: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none), { color: theme.isFlyingFlowers ? colors.black[700] : colors.grey.grey6, width: '100%', display: 'flex', alignItems: 'center', [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.medium_regular), theme.typographySpacing.none) }),
    linkText: Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.xxs_regular), theme.typographySpacing.none), link(theme.isFlyingFlowers ? colors.black[700] : colors.primary.gold5)), { color: theme.isFlyingFlowers ? colors.black[700] : colors.primary.gold5, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none) }),
    selectedValueText: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none), { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '75%', textAlign: 'left', [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_regular), theme.typographySpacing.none), { width: '85%' }) }),
    pccStepSelectButton: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },
    selected: {
        color: colors.supplementary.black,
    },
    stepCompleted: {
        color: theme.isFlyingFlowers ? colors.black[700] : colors.grey.grey6,
        cursor: 'pointer',
        marginBottom: `${spacing.medium} !important`,
    },
    activeStep: {
        cursor: 'pointer',
        marginBottom: spacing.small,
        [theme.breakpoints.up('md')]: {
            marginBottom: spacing.medium,
        },
    },
    iconColor: {
        color: theme.statusColors.success.base,
        marginRight: spacing.xs,
    },
    iconSize: {
        '& .MuiIcon-root': {
            fontSize: spacing.medium,
            [theme.breakpoints.up('md')]: {
                fontSize: '28px',
            },
        },
    },
    inActiveColor: {
        color: theme.isFlyingFlowers ? colors.black[600] : 'initial',
    },
    stepInActive: {
        color: colors.grey.grey6,
    },
    completedStepLabel: {
        color: colors.grey.grey6,
    },
    activeStepLabel: {
        color: colors.supplementary.black,
    },
    stepNumber: {
        display: _params.showAllOccasions || (_params === null || _params === void 0 ? void 0 : _params.isManualAddressSelection) ? 'none' : 'block',
        marginRight: spacing.xs,
    },
    addressFieldTouched: {
        marginTop: '50px',
    },
    nonAddressFieldTouched: {
        marginTop: '0',
    },
    pccStepSelectButtonEdit: {
        cursor: 'pointer',
    },
    pccEditSelectedValue: {
        display: 'flex',
        width: '100%',
    },
    pccEditSelectedValueText: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        width: '75%',
        [theme.breakpoints.up('md')]: {
            width: 'auto',
        },
    },
    editIconColor: {
        color: colors.primary.gold5,
        marginLeft: spacing.small,
        height: spacing.medium,
        width: spacing.medium,
        display: 'inline-flex',
    },
}));
export default useStyles;
